import { useSelector } from "react-redux";
import { useRothko } from "web/react/hooks/use-rothko/use-rothko";
import { ReduxStoreState } from "web/redux/store";
import { FeedFiltersSerializer, FilterOptionSerializer } from "web/types/serializers";

interface UseLazyFacetResults {
    isFetching: boolean;
    options: FilterOptionSerializer[];
    label: string;
}

export function useLazyFilter(sectionId: string): UseLazyFacetResults {
    const url = useSelector((state: ReduxStoreState) => state.filters.ui.url);
    const filter = useSelector((state: ReduxStoreState) =>
        state.filters.data?.filters?.find?.((filter) => filter.id === sectionId)
    );

    if (!url) {
        throw new Error(`A feed url is required`);
    }

    if (!filter) {
        throw new Error(`No filter found for ${sectionId}`);
    }

    const { isFetching, data } = useRothko<FeedFiltersSerializer>( // fetch data here
        "modules/filters_lazy_load",
        `?feed_url=${encodeURIComponent(url)}&facets=${sectionId}`,
        {
            enabled: true,
            rothko: {
                cache: true,
            },
        }
    );

    const options = data?.filters?.find?.((filter) => filter.id === sectionId)?.options ?? [];

    return { isFetching, options, label: filter.label };
}
